<template>
    <Dialog class="dialogBox" v-model:visible="visible" modal header="Vegotari pakutav teenus">
        <div class="dialogBody">
            <Galleria v-model:activeIndex="activeIndex" v-model:visible="displayCustom" :value="serviceData.gallery" :numVisible="7"
                containerStyle="max-width: 850px" :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false">
                <template #item="slotProps">
                    <img :src="require('../../assets/shopLanding/banner/'+slotProps.item)" style="width: 100%; display: block" />
                </template>
                <template #thumbnail="slotProps">
                    <img :src="require('../../assets/shopLanding/banner/'+slotProps.item)"  style="display: block" />
                </template>
            </Galleria>

            <div v-if="serviceData.gallery.length > 0" class="imagesGrid">
                <div v-for="(image, index) of serviceData.gallery" :key="index" class="">
                    <img :src="require('../../assets/shopLanding/banner/'+image)" style="cursor: pointer" @click="imageClick(index)" />
                </div>
            </div>
            <h3>{{ serviceData.client }}</h3>
            <h2>{{ serviceData.title }}</h2>
            <p>{{ serviceData.text }}</p>
        </div>
    </Dialog>
</template>
  
<script>
// import Button from 'primevue/button'
import Dialog from 'primevue/dialog';
import Galleria from 'primevue/galleria';

export default {
    name: 'contactPopup',
    components: {
        // Button,
        Dialog,
        Galleria
    },
    props: {
        serviceData: null
    },
    data() {
        return {
            visible: false,
            displayCustom: false,
            activeIndex: -1
        };
    },
    computed: {
      
    },
    methods: {
        imageClick(index) {
            this.displayCustom = true
            this.activeIndex = index
        }
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
<style>
.errMsg .p-message-text {
    text-align: start;
}
</style>
<style scoped>
.errMsg {
    margin-top: 5px;
}
.dialogBody {
    position: relative;
    width: 750px;
}
.imagesGrid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    row-gap: 12px;
    column-gap: 15px;
}
.imagesGrid div {
    width: 32%;
}
.imagesGrid img {
    width: 100%;
    height: 200px;
    border-radius: 5px;
    object-fit: cover;
}
.bar {
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
    position: fixed;
    z-index: 1200;
    bottom: 0;
    background: white;
}
.bar h2 {
    margin: 0;
    margin-top: auto;
    position: absolute;
    left: 140px;
    bottom: -6px;
    color: rgb(173, 194, 214);
    font-size: 24px;
}
.bar img {
    margin-left: -4px;
}
h1 {
    position: absolute;
    right: 0;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 24px;
    color: steelblue;
}
.navBody {
    position: relative;
    width: 1300px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
@media (max-width: 1340px) {
    .navBody {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
    h1 {
        position: relative;
    }
}
@media (max-width: 750px) {
    h1 {
        font-size: 3.5vw;
        text-align: end;
    }
    img {
        margin-right: 20px;
    }
}
</style>